import clsx from "clsx";

export type SkeletonVariant = "list" | "table" | "text" | "card";

/** Placeholder for loads under ~2 s (§3). Longer waits use JobProgress with real numbers. */
export function Skeleton({ rows = 3, variant = "list", className }: { rows?: number; variant?: SkeletonVariant; className?: string }) {
  const items = Array.from({ length: rows }, (_, i) => i);
  return (
    <div className={clsx("flex flex-col", variant === "card" ? "gap-4" : "gap-3.5", className)} aria-busy="true" aria-live="polite">
      {items.map((i) => {
        if (variant === "text") return <div key={i} className="iga-skeleton h-3" style={{ width: `${[90, 70, 80, 55][i % 4]}%` }} />;
        if (variant === "table") return (
          <div key={i} className="flex items-center gap-4">
            <div className="iga-skeleton h-3" style={{ width: "28%" }} /><div className="iga-skeleton h-5 w-24 rounded-full" /><div className="iga-skeleton h-3" style={{ width: "18%" }} /><div className="iga-skeleton h-3" style={{ width: "12%" }} />
          </div>
        );
        if (variant === "card") return (
          <div key={i} className="iga-card flex flex-col gap-3 p-4">
            <div className="iga-skeleton h-3.5" style={{ width: "40%" }} /><div className="iga-skeleton h-3" style={{ width: "85%" }} /><div className="iga-skeleton h-3" style={{ width: "60%" }} />
          </div>
        );
        return (
          <div key={i} className="flex items-center gap-4">
            <div className="iga-skeleton h-8 w-8 rounded-full" />
            <div className="flex flex-1 flex-col gap-1.5"><div className="iga-skeleton h-3" style={{ width: `${[40, 55, 35][i % 3]}%` }} /><div className="iga-skeleton h-2.5" style={{ width: `${[25, 30, 20][i % 3]}%` }} /></div>
            <div className="iga-skeleton h-[22px] w-[90px] rounded-full" />
          </div>
        );
      })}
    </div>
  );
}
